import React, { useEffect, useRef, useState } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import print2 from "src/assets/Images/print2.png";
import print1 from "src/assets/Images/Print 1.png";
import print3 from "src/assets/Images/print3.png";
import { errorHandling } from "src/shared/utils/errorHandling";
import { useUser } from "src/business-types/grocery/components/UserContext";
import DropdownSelect from "src/business-types/grocery/components/DropdownSelect";
import useConfigration from "src/business-types/grocery/hooks/useConfigration";
import { notifyWarning } from "src/assets/toastService";
import { normalizeFoodTypes } from "src/shared/utils/normalizeFoodTypes";
import { Switch } from "@mui/material";
import Image from "src/shared/Image";
import InputBox from "src/business-types/grocery/components/InputBox";
import { normalizeShiftTypes } from "src/shared/utils/normalizeShiftTypes";

const dropDownValue = [
  { _id: "10", CategoryName: "10" },
  { _id: "25", CategoryName: "25" },
  { _id: "50", CategoryName: "50" },
  { _id: "100", CategoryName: "100" },
  { _id: "250", CategoryName: "250" },
  { _id: "500", CategoryName: "500" },
];

const billNoDropDownValue = [
  { _id: "noreset", CategoryName: "No reset" },
  { _id: "day", CategoryName: "Day" },
  { _id: "week", CategoryName: "Week" },
  { _id: "month", CategoryName: "Month" },
  { _id: "year", CategoryName: "Year" },
];

const DEFAULT_FOOD_TYPES = ["Veg", "Non-Veg"];
const MAX_TYPES = 5;

const DEFAULT_SHIFT_MANAGE = ["Morning Shift", "Evening Shift"];
const Max_SHIFT = 5;

const Configuration = () => {
  const { user } = useUser();
  const { config, postConfig } = useConfigration();
  const [printType, setPrintType] = useState<"print:1" | "print:2" | "print:3">("print:1");
  const [orderTableType, setOrderTableType] = useState<"Table Type:1" | "Table Type:2">("Table Type:1");
  const [tableRows, setTableRows] = useState<number>(10);
  const [isDualCopy, setIsDualCopy] = useState(false);
  const [billNo, setBillNo] = useState("noreset");
  const [billNoEnabled, setBillNoEnabled] = useState(false);
  const [foodTypes, setFoodTypes] = useState<string[]>(DEFAULT_FOOD_TYPES);
  const [newType, setNewType] = useState("");
  const [addTC, setAddTC] = useState(false);
  const [tcEnglish, setTcEnglish] = useState("");
  const [tcArabic, setTcArabic] = useState("");
  const [deliveryFeeEnabled, setDeliveryFeeEnabled] = useState(false);
  const [pdfProductLimit, setPdfProductLimit] = useState<string>("10");
  const [showOutstanding, setShowOutstanding] = useState<boolean>(true);
  const [isProductsNotesEnabled, setIsProductsNotesEnabled] = useState(false);
  const [isDefaultTabsEnabled, setIsDefaultTabsEnabled] = useState(false);
  const [businessName, setBusinessName] = useState<string>("Grocery");
  const [businessOperationEnable, setBusinessOperationEnable] = useState(false);
  const [businessOperationType, setBusinessOperationType] = useState<"Day" | "Shift">("Day");
  const [shiftTypes, setShiftTypes] = useState<string[]>(DEFAULT_SHIFT_MANAGE);
  const [newShift, setNewShift] = useState<string>("");
  const [printProductLimit, setPrintProductLimit] = useState<string>("5");

  // Add a shift
  const addShift = () => {
    const trimmedShift = newShift.trim();
    if (trimmedShift && !shiftTypes.includes(trimmedShift) && shiftTypes.length < Max_SHIFT) {
      setShiftTypes([...shiftTypes, trimmedShift]);
      setNewShift("");
    }
  };

  // Remove a shift
  const removeShift = (shift: string) => {
    setShiftTypes(shiftTypes.filter((s) => s !== shift));
  };

  // ✅ QR refs
  const contactInputRef = useRef<HTMLInputElement | null>(null);
  const locationInputRef = useRef<HTMLInputElement | null>(null);

  const [contactQR, setContactQR] = useState<{
    file: File | null;
    preview: string;
  }>({ file: null, preview: "" });

  const [locationQR, setLocationQR] = useState<{
    file: File | null;
    preview: string;
  }>({ file: null, preview: "" });

  // ---------------------------
  // FOOD TYPES
  // ---------------------------
  const addFoodType = () => {
    if (newType.trim() && !foodTypes.includes(newType.trim()) && foodTypes.length < MAX_TYPES) {
      setFoodTypes([...foodTypes, newType.trim()]);
      setNewType("");
    }
  };

  const removeFoodType = (type: string) => {
    setFoodTypes(foodTypes.filter((t) => t !== type));
  };

  // ---------------------------
  // IMAGE HANDLING
  // ---------------------------
  const handleSimpleImageUpload = (e: React.ChangeEvent<HTMLInputElement>, setter: any) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      notifyWarning("Only image files allowed");
      return;
    }

    const preview = URL.createObjectURL(file);
    setter({ file, preview });
  };

  const removeContactQR = () => {
    if (contactQR.preview) URL.revokeObjectURL(contactQR.preview);
    setContactQR({ file: null, preview: "" });
  };

  const removeLocationQR = () => {
    if (locationQR.preview) URL.revokeObjectURL(locationQR.preview);
    setLocationQR({ file: null, preview: "" });
  };

  useEffect(() => {
    if (orderTableType === "Table Type:2" && printType === "print:1") {
      setPrintType("print:2");
      notifyWarning("Print Type 1 is not supported in Table Type 2.");
    }
  }, [orderTableType, printType]);

  // ---------------------------
  // UPDATE API
  // ---------------------------
  const update = async () => {
    try {
      const printData = {
        organization_id: String(user?.organization_id),
        printType,
        billResetPeriod: billNoEnabled ? billNo : "noreset",
        billNoEnabled: billNoEnabled ? "true" : "false",
        tableDefultSize: String(tableRows),
        copyqty: String(isDualCopy ? 2 : 1),
        foodTypes: JSON.stringify(foodTypes),
        termsAndConditionsEnglish: addTC ? tcEnglish : "",
        termsAndConditionsArabic: addTC ? tcArabic : "",
        enabileTermsAndConditions: addTC ? "true" : "false",
        isProductsNotesEnabled: isProductsNotesEnabled ? "true" : "false",
        isDefaultTabsEnabled: isDefaultTabsEnabled ? "true" : "false",
        deliveryFeeEnabled: String(deliveryFeeEnabled),
        businessOperationEnable: businessOperationEnable ? "true" : "false",
        businessOperationType: businessOperationType,
        shiftTypes: JSON.stringify(shiftTypes),
        pdfProductLimit: pdfProductLimit,
        showOutstandingInPdf: String(showOutstanding),
        customBusinessName: String(businessName),
        orderTableType: String(orderTableType),
        printProductLimit: printProductLimit,
      };

      const dataToSend = new FormData();

      Object.entries(printData).forEach(([key, value]) => {
        dataToSend.append(key, value);
      });
      if (contactQR.file) {
        dataToSend.append("contact_qr_code", contactQR.file);
      } else if (!contactQR.preview) dataToSend.append("contact_qr_code", "");
      if (locationQR.file) {
        dataToSend.append("location_qr_code", locationQR.file);
      } else if (!locationQR.preview) dataToSend.append("location_qr_code", "");
      await postConfig(dataToSend);
    } catch (error) {
      errorHandling(error);
    }
  };

  const toBoolean = (value: any) => value === true || value === "true";

  useEffect(() => {
    console.log(contactQR, locationQR);
  }, [contactQR, locationQR]);

  // ---------------------------
  // LOAD CONFIG
  // ---------------------------
  useEffect(() => {
    if (!config) return;

    setPrintType(config?.printType || "print:1");
    setTableRows(config?.tableDefultSize || 10);
    setBillNo(config?.billResetPeriod || "noreset");
    setBillNoEnabled(toBoolean(config?.billNoEnabled));
    setIsDualCopy(config?.copyqty > 1);
    setAddTC(toBoolean(config?.enabileTermsAndConditions));
    setTcEnglish(config?.termsAndConditionsEnglish || "");
    setTcArabic(config?.termsAndConditionsArabic || "");
    setIsProductsNotesEnabled(toBoolean(config?.isProductsNotesEnabled));
    setIsDefaultTabsEnabled(toBoolean(config?.isDefaultTabsEnabled));
    setFoodTypes(normalizeFoodTypes(config?.foodTypes || []));
    setShiftTypes([...DEFAULT_SHIFT_MANAGE.filter((def) => !(config?.shiftTypes || []).includes(def)), ...normalizeShiftTypes(config?.shiftTypes || [])]);
    setContactQR((prev) => ({ ...prev, preview: config.contact_qr_code || "" }));
    setLocationQR((prev) => ({ ...prev, preview: config.location_qr_code || "" }));
    setDeliveryFeeEnabled(toBoolean(config?.deliveryFeeEnabled));
    setBusinessOperationEnable(toBoolean(config?.businessOperationEnable));
    setBusinessOperationType(config?.businessOperationType || "Day");

    setPdfProductLimit(config?.pdfProductLimit || "10");
    if (config?.showOutstandingInPdf !== undefined && config?.showOutstandingInPdf !== null) {
      setShowOutstanding(toBoolean(config.showOutstandingInPdf));
    } else {
      setShowOutstanding(true);
    }
    setBusinessName(config.customBusinessName || "Grocery");
    setOrderTableType((config?.orderTableType as "Table Type:1" | "Table Type:2") || "Table Type:1");
  }, [config]);

  const disable =
    config &&
    config.printType === printType &&
    config.billResetPeriod === (billNoEnabled ? billNo : "noreset") &&
    JSON.stringify(normalizeFoodTypes(config.foodTypes)) === JSON.stringify(foodTypes) &&
    JSON.stringify(normalizeShiftTypes(config.shiftTypes)) === JSON.stringify(shiftTypes) &&
    config.copyqty === (isDualCopy ? 2 : 1) &&
    config.termsAndConditionsEnglish === (addTC ? tcEnglish : "") &&
    config.termsAndConditionsArabic === (addTC ? tcArabic : "") &&
    config.enabileTermsAndConditions === (addTC || false) &&
    config.isProductsNotesEnabled === (isProductsNotesEnabled || false) &&
    config.isDefaultTabsEnabled === (isDefaultTabsEnabled || false) &&
    config.billNoEnabled === (billNoEnabled || false) &&
    ((contactQR.preview && contactQR.preview === config.contact_qr_code) || (!contactQR.preview && !config.contact_qr_code)) &&
    ((locationQR.preview && locationQR.preview === config.location_qr_code) || (!locationQR.preview && !config.location_qr_code)) &&
    config?.deliveryFeeEnabled === deliveryFeeEnabled &&
    config?.customBusinessName === businessName &&
    config?.pdfProductLimit === pdfProductLimit &&
    config?.showOutstandingInPdf === showOutstanding &&
    config?.businessOperationEnable === businessOperationEnable &&
    config?.businessOperationType === businessOperationType &&
    config?.printProductLimit === printProductLimit;

  return (
    <div className={`w-full ${user?.business_type === "Grocery" ? "h-fit" : "h-[70vh]"} space-y-6`}>
      {/* PRINT TYPE */}
      <div className="border p-4 rounded-xl shadow bg-white">
        <h2 className="text-lg font-semibold mb-3">Select Print Type</h2>

        <div className="flex gap-6">
          {[
            { type: "print:1", img: print1, lable: "Print type: 1", disable: orderTableType === "Table Type:2" },
            { type: "print:2", img: print2, lable: "Print type: 2" },
            { type: "print:3", img: print3, lable: "Print type: 3" },
          ].map((item) => (
            <label key={item.type} className="flex flex-col items-start gap-3 cursor-pointer">
              <div className="flex items-center gap-2">
                <input type="radio" checked={printType === item.type} onChange={() => setPrintType(item.type as any)} disabled={item.disable} />
                <p>{item.lable}</p>
              </div>
              <img src={item.img} className="w-40 border rounded" alt="" />
            </label>
          ))}
        </div>

        <div className="flex gap-6">
          {[
            { type: "Table Type:1", value: "Table Type 1" },
            { type: "Table Type:2", value: "Table Type 2" },
          ].map((item) => (
            <label key={item.type} className="flex flex-col items-start gap-3 cursor-pointer">
              <div className="flex items-center gap-2">
                <input type="radio" checked={orderTableType === item.type} onChange={() => setOrderTableType(item.type as any)} />
                <p>{item.type}</p>
              </div>
            </label>
          ))}
        </div>

        <label className="flex items-center gap-2 mt-4">
          <input type="checkbox" checked={isDualCopy} onChange={(e) => setIsDualCopy(e.target.checked)} />
          Dual Copy
        </label>
      </div>

      {/* Table + Bill Configuration */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Table Configuration */}
        <div className="border p-4 rounded-xl shadow bg-white">
          <h2 className="text-lg font-semibold">Table Configuration</h2>

          <div className="mt-4">
            <label className="block text-sm font-medium mb-1">
              Table Data Shown (Rows)
              <span className="text-gray-400 ml-2">(10 / 25 / 50 / 100 / 250 / 500)</span>
            </label>

            <DropdownSelect name="" titleofSelect="Table Data Shown" value={String(tableRows)} options={dropDownValue} onChange={(value) => setTableRows(Number(value))} />
          </div>
        </div>

        {/* Bill No Configuration */}
        <div className="border p-4 rounded-xl shadow bg-white">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-lg font-semibold">Bill Number</h2>

            <label className="flex items-center gap-2 text-sm font-medium cursor-pointer select-none">
              <input type="checkbox" checked={billNoEnabled} onChange={() => setBillNoEnabled(!billNoEnabled)} className="accent-blue-600 w-4 h-4" />
              Enable Bill No
            </label>
          </div>
          <div className="mt-4">
            <label className="block text-sm font-medium mb-1">
              Bill Number Reset Period
              <span className="text-gray-400 ml-2">(No reset / Day / Week / Month / Year)</span>
            </label>
            <DropdownSelect titleofSelect="Bill No Reset Period" name="" value={billNo} defultSelect options={billNoDropDownValue} onChange={(e) => setBillNo(e)} disabled={!billNoEnabled} />
          </div>
          {!billNoEnabled && <p className="text-xs text-gray-500 mt-2">Enable bill number reset to select period</p>}
        </div>
      </div>

      <div className="w-full flex gap-4">
        <div className={`border p-4  rounded-xl shadow bg-white flex gap-4 ${user?.business_type === "Grocery" ? "w-1/2" : "w-full"} justify-center items-center`}>
          <div className="flex flex-col items-center justify-between gap-2 w-full">
            <h2 className="text-lg font-semibold w-full">Delivery Fee</h2>

            <label className={`flex items-center gap-2 cursor-pointer select-none`}>
              <input type="checkbox" checked={deliveryFeeEnabled} onChange={() => setDeliveryFeeEnabled(!deliveryFeeEnabled)} className="accent-blue-600 w-4 h-4" />
              Enable Delivery Fee
            </label>
            {!deliveryFeeEnabled && <p className="text-xs text-gray-500 mt-2">Enable delivery fee to allow adding delivery charges</p>}
          </div>
        </div>
        {user?.business_type === "Grocery" && (
          <div className="border p-4  rounded-xl shadow bg-white flex gap-2 w-1/2 justify-center items-center">
            <div className="flex flex-col items-center justify-between gap-2 w-full">
              <h2 className="text-lg font-semibold w-full">Customised Business Name</h2>

              <label className="flex items-center gap-2 cursor-pointer select-none">
                Business Name :
                <InputBox placeholder="Business Name" onChange={(e) => setBusinessName(e.target.value)} value={businessName} />
              </label>
            </div>
          </div>
        )}
      </div>

      {/* Shift Open/Close Configuration */}
      {/* Business Operation Configuration */}
      {user?.business_type === "Restaurant" && (
        <div className="border p-4 rounded-xl shadow bg-white">
          <h2 className="text-lg font-semibold mb-3">Business Operation Configuration</h2>

          {/* Enable Toggle */}
          <div className="flex items-center gap-2 mb-4">
            <input type="checkbox" checked={businessOperationEnable} onChange={() => setBusinessOperationEnable(!businessOperationEnable)} className="accent-blue-600 w-4 h-4" />
            <span>Enable Business Operation</span>
          </div>

          {!businessOperationEnable && <p className="text-xs text-gray-500 mb-3">Enable this to allow Day or Shift open/close operations.</p>}
          {/* {currentStatus === "OPEN" && (
          <div className="mt-3 mb-3 flex items-start gap-2 p-2 rounded-lg bg-amber-50 border border-amber-300 text-amber-800 text-sm">
            <span className="text-lg">⚠</span>
            <p>A business operation is currently active. Close the open Day or Shift before disabling this feature.</p>
          </div>
        )} */}

          {businessOperationEnable && (
            <>
              {/* Operation Type */}
              <div className="mb-4">
                <label className="text-sm font-medium mr-4">Operation Type:</label>

                <div className="inline-flex items-center gap-6">
                  <label className="flex items-center">
                    <input type="radio" value="Day" checked={businessOperationType === "Day"} onChange={() => setBusinessOperationType("Day")} className="mr-1" />
                    Day
                  </label>

                  <label className="flex items-center">
                    <input type="radio" value="Shift" checked={businessOperationType === "Shift"} onChange={() => setBusinessOperationType("Shift")} className="mr-1" />
                    Shift
                  </label>
                </div>
              </div>

              {businessOperationEnable && (
                <div className="mt-4">
                  <label className="block text-sm font-semibold text-gray-700 mb-3">Maximum Products show Print</label>

                  <select
                    value={printProductLimit}
                    onChange={(e) => setPrintProductLimit(e.target.value)}
                    className="w-full h-11 rounded-lg border border-gray-300 bg-white px-4 text-sm
                 focus:outline-none focus:ring-2 focus:ring-blue-500
                 focus:border-blue-500 transition duration-200"
                  >
                    <option value="5">5 Products</option>
                    <option value="10">10 Products</option>
                    <option value="20">20 Products</option>
                    <option value="50">50 Products</option>
                    <option value="100">100 Products</option>
                    <option value="all">Show All</option>
                  </select>

                  <p className="text-xs text-gray-500 mt-3">Choose how many products should appear in printed bills.</p>
                </div>
              )}

              {/* Shift Management */}
              {businessOperationType === "Shift" && (
                <>
                  <p className="text-sm text-gray-600 mb-2">Manage Shifts</p>

                  <div className="flex flex-wrap gap-2 mb-3">
                    {shiftTypes.map((shift, index) => (
                      <div key={index} className="flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                        <span>{shift}</span>
                        <button onClick={() => removeShift(shift)} className="text-red-600 hover:text-red-800 font-bold">
                          ×
                        </button>
                      </div>
                    ))}
                  </div>

                  {shiftTypes.length < 5 && (
                    <div className="flex gap-2 mb-3">
                      <input type="text" value={newShift} onChange={(e) => setNewShift(e.target.value)} placeholder="Add shift" className="border px-3 py-2 rounded-md text-sm w-48" />
                      <button onClick={addShift} className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm">
                        Add Shift
                      </button>
                    </div>
                  )}

                  {shiftTypes.length >= 5 && <p className="text-xs text-red-500 mt-2">Maximum 5 shifts allowed</p>}
                </>
              )}
            </>
          )}
        </div>
      )}

      {/* Res Configratin on Section */}
      {user?.business_type === "Restaurant" && (
        <div className="border p-4 rounded-xl shadow bg-white">
          <h2 className="text-lg font-semibold mb-3">Restaurant Food Types Configuration</h2>

          <p className="text-sm text-gray-600 mb-2">Configure food categories for your restaurant</p>

          {/* Food Type List */}
          <div className="flex flex-wrap gap-2 mb-3">
            {foodTypes.map((type, index) => (
              <div key={index} className="flex items-center gap-2 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
                <span>{type}</span>

                {/* ❌ Cancel Button */}
                <button onClick={() => removeFoodType(type)} className="text-red-600 hover:text-red-800 font-bold">
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Add New Type */}
          {foodTypes.length < 5 && (
            <div className="flex gap-2">
              <input type="text" value={newType} onChange={(e) => setNewType(e.target.value)} placeholder="Add food type" className="border px-3 py-2 rounded-md text-sm w-48" />
              <button onClick={addFoodType} className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm">
                Add
              </button>
            </div>
          )}

          {foodTypes.length >= 5 && <p className="text-xs text-red-500 mt-2">Maximum 5 food types allowed</p>}
        </div>
      )}

      <div className="w-full border p-4 rounded-xl shadow bg-white space-y-4">
        <h1 className="text-xl font-bold">Add Terms and Conditions in print</h1>
        <div className="w-full flex items-center mb-4 ml-1">
          <input type="checkbox" checked={addTC} onChange={() => setAddTC(!addTC)} />
          <span className="ml-2">Add Terms and Conditions</span>
        </div>
        <div className="flex gap-4 w-full ml-1">
          <div className="w-1/2">
            <h2 className="text-lg font-semibold mb-2">Language 1 :</h2>
            <textarea
              className="w-full h-16 border rounded-md p-2 text-sm"
              placeholder="Enter additional notes..."
              disabled={!addTC}
              value={tcEnglish}
              onChange={(e) => setTcEnglish(e.target.value)}
            />
          </div>
          <div className="w-1/2">
            <h2 className="text-lg font-semibold mb-2">Language 2 :</h2>

            <textarea className="w-full h-16 border rounded-md p-2 text-sm" placeholder="Enter additional notes..." disabled={!addTC} value={tcArabic} onChange={(e) => setTcArabic(e.target.value)} />
          </div>
        </div>
      </div>

      {/* QR SECTION */}
      <div className="grid grid-cols-2 gap-6">
        {/* Contact */}
        <div className="border p-4 rounded-xl bg-white text-center">
          <h2 className="font-semibold mb-3">Contact QR</h2>

          <div onClick={() => contactInputRef.current?.click()} className="w-40 h-40 mx-auto border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer">
            {contactQR.preview ? <Image className="w-full h-full object-contain" imagePath={contactQR.preview} /> : <span>Click to upload</span>}
            <input ref={contactInputRef} type="file" accept="image/*" onChange={(e) => handleSimpleImageUpload(e, setContactQR)} className="hidden" />
          </div>
          <div className="flex w-full justify-center items-center">{contactQR.preview && <Button label="Remove" variant="danger" onClick={removeContactQR} />}</div>
        </div>

        {/* Location */}
        <div className="border p-4 rounded-xl bg-white text-center mt-2">
          <h2 className="font-semibold mb-3">Location QR</h2>

          <div onClick={() => locationInputRef.current?.click()} className="w-40 h-40 mx-auto border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer">
            {locationQR.preview ? <Image className="w-full h-full object-contain" imagePath={locationQR.preview} /> : <span>Click to upload</span>}
            <input ref={locationInputRef} type="file" accept="image/*" onChange={(e) => handleSimpleImageUpload(e, setLocationQR)} className="hidden" />
          </div>
          <div className="w-full flex justify-center items-center mt-2">{locationQR.preview && <Button label="Remove" variant="danger" onClick={removeLocationQR} />}</div>
        </div>
      </div>
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-md border border-gray-100 p-8">
        {/* Header */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 tracking-tight">Daily Report</h2>
          <p className="text-sm text-gray-500 mt-1">Configure how your PDF reports should appear.</p>
        </div>

        {/* Settings Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Product Limit Card */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:shadow-sm transition duration-200">
            <label className="block text-sm font-semibold text-gray-700 mb-3">Maximum Products in PDF</label>

            <select
              value={pdfProductLimit}
              onChange={(e) => setPdfProductLimit(e.target.value)}
              className="w-full h-11 rounded-lg border border-gray-300 bg-white px-4 text-sm
                   focus:outline-none focus:ring-2 focus:ring-blue-500 
                   focus:border-blue-500 transition duration-200"
            >
              <option value="10">10 Products</option>
              <option value="20">20 Products</option>
              <option value="50">50 Products</option>
              <option value="100">100 Products</option>
              <option value="all">Show All</option>
            </select>

            <p className="text-xs text-gray-500 mt-3 leading-relaxed">Choose how many products should appear in the generated PDF.</p>
          </div>

          {/* Outstanding Toggle Card */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:shadow-sm transition duration-200">
            <label className="block text-sm font-semibold text-gray-700 mb-3">Display Outstanding Balance</label>

            <div className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-3">
              <span className="text-sm text-gray-600">{showOutstanding ? "Outstanding shown" : "Outstanding hidden"}</span>

              <Switch checked={showOutstanding} onChange={(e: { target: { checked: boolean } }) => setShowOutstanding(e.target.checked)} color="primary" />
            </div>

            <p className="text-xs text-gray-500 mt-3 leading-relaxed">Enable to include outstanding balance details in the PDF.</p>
          </div>
        </div>
      </div>

      {user?.business_type === "Grocery" && (
        <div className="w-full border p-4 rounded-xl shadow bg-white space-y-4">
          <h1 className="text-xl font-bold">Homepage design options</h1>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium cursor-pointer select-none">
              <input type="checkbox" className="accent-blue-600 w-4 h-4" checked={isDefaultTabsEnabled} onChange={() => setIsDefaultTabsEnabled(!isDefaultTabsEnabled)} />
              Default product tabs
            </label>
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium cursor-pointer select-none">
              <input type="checkbox" className="accent-blue-600 w-4 h-4" checked={isProductsNotesEnabled} onChange={() => setIsProductsNotesEnabled(!isProductsNotesEnabled)} />
              Selected Product Customes Notes section
            </label>
          </div>
        </div>
      )}

      <div className="flex justify-center">
        <Button label="Update" onClick={update} disabled={disable} />
      </div>
    </div>
  );
};

export default Configuration;
